<template>
  <div class="header-wrapper">
    <img class="logo" @touchend="toPage('/')" src="/static/img/header-logo.png" alt>
    <div class="logo-text">
      <img src="/static/img/header-title.png" alt>
      <img src="/static/img/header-title2.png" alt>
    </div>
    <div class="lan-tab">
      <span>English</span>/
      <span class="lan-tab-active">中文</span>
    </div>
    <div class="option-icon" v-if="!indexSlide" @touchend="openMenu">
      <img class="img1"  src="/static/img/header-menu.png" alt >
    </div>
     <div class="option-icon" v-if="indexSlide" @touchend="closeMenu">
      <img class="img2" src="/static/img/header-close.png" alt >
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["indexSlide"])
  },
  methods:{
      ...mapActions(['openMenu','closeMenu']),
      toPage(url) {
      this.$router.push(url);
    },
  }
};
</script>

<style lang="less" scoped>
@import "../../common/minix.less";
.header-wrapper {
  width: 100%;
  height: 100%;
  background: #284faa;
  padding: 0 0 0 20/@rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  .lan-tab{
    color: #71a7e8;
    font-size: 22/@rem;
  }
  .lan-tab-active{
    color: #fff;
  }
  .logo {
    width: 79 / @rem;
    height: 80 / @rem;
    margin-right: 20 / @rem;
  }
  .logo-text {
    flex: 1;
    display: flex;
    flex-direction: column;
    img {
      width: 278 / @rem;
    }
  }
  .option-icon{
    padding: 20px;
    box-sizing: border-box;
    img{
      display: block;
    }
    .img1{
      width: 36/@rem;
      height: 30/@rem;
    }
    .img2{
      width: 28/@rem;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/common/header.vue